<div class="aig-text">
    <p>
        Utilizamos cookies y tecnologías similares propias y de terceros, 
        de sesión o persistentes, para hacer funcionar de manera segura nuestra 
        página web y personalizar su contenido Igualmente, utilizamos cookies 
        para medir y obtener datos de la navegación que realizas y para ajustar 
        la publicidad a tus gustos y preferencias. Puedes configurar y aceptar 
        el uso de cookies a continuación. Asimismo, puedes modificar tus 
        opciones de consentimiento en cualquier momento visitando nuestra 
        Política de Cookies y obtener más información haciendo clic
        <a class="u-color-primary3 u-cursor-pointer" target="_blank" href="https://www.aig.com.es/politica-de-cookies">aquí</a>
    </p>
</div>